import React from 'react'

const FilePreview = ({ base64String, fileType }) => {
  const isExcel = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ].includes(fileType);

  if (fileType.startsWith('image/')) {
    return <img src={`data:${fileType};base64,${base64String}`} alt="Preview" height={"85%"} width={"100%"}/>;
  } else if (fileType === 'application/pdf') {
    return (
      <embed
     
        type="application/pdf"
        src={`data:application/pdf;base64,${base64String}`}
        width="100%"
        height="85%"
      />
    );
  } 

  else {
    // Handle other file types as needed
    return <div style={{fontWeight:600,fontSize:18}}>Unsupported file type</div>;
  }
};

export default FilePreview